var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 20.706C11.48 20.895 11.735 21 12 21C12.266 21 12.52 20.895 12.708 20.707L20.476 12.926C22.512 10.886 22.512 7.567 20.475 5.527C19.492 4.543 18.179 4 16.781 4C15.381 4 14.069 4.543 13.085 5.528L12 6.614L10.915 5.527C9.93205 4.543 8.61905 4 7.22005 4C5.82105 4 4.50905 4.543 3.52505 5.527C1.48905 7.567 1.48905 10.886 3.52505 12.926L11.293 20.706ZM4.94005 6.941C5.54605 6.334 6.35605 6 7.22005 6C8.08505 6 8.89405 6.334 9.50005 6.94L11.292 8.736C11.668 9.113 12.332 9.113 12.708 8.736L14.5 6.941C15.712 5.728 17.848 5.726 19.06 6.941C20.319 8.201 20.319 10.252 19.06 11.514L12 18.585L4.94105 11.514C3.68205 10.252 3.68205 8.201 4.94005 6.941Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1157_13206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 22,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 20.706C11.48 20.895 11.735 21 12 21C12.266 21 12.52 20.895 12.708 20.707L20.476 12.926C22.512 10.886 22.512 7.567 20.475 5.527C19.492 4.543 18.179 4 16.781 4C15.381 4 14.069 4.543 13.085 5.528L12 6.614L10.915 5.527C9.93205 4.543 8.61905 4 7.22005 4C5.82105 4 4.50905 4.543 3.52505 5.527C1.48905 7.567 1.48905 10.886 3.52505 12.926L11.293 20.706ZM4.94005 6.941C5.54605 6.334 6.35605 6 7.22005 6C8.08505 6 8.89405 6.334 9.50005 6.94L11.292 8.736C11.668 9.113 12.332 9.113 12.708 8.736L14.5 6.941C15.712 5.728 17.848 5.726 19.06 6.941C20.319 8.201 20.319 10.252 19.06 11.514L12 18.585L4.94105 11.514C3.68205 10.252 3.68205 8.201 4.94005 6.941Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1157_13206)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.a60cc0431276b93a9295743c99fe874a.svg";
export { ForwardRef as ReactComponent };